import { useTranslation } from 'react-i18next';

import { getConfigs } from '../constants/configs';
import { SimpleLanguage } from '../enum';
import { useEnvironment } from './use-environment';

export function useConfig() {
  const { environment } = useEnvironment();
  const { i18n } = useTranslation();
  const lang = (i18n?.language as SimpleLanguage) || SimpleLanguage.en;

  return {
    config: getConfigs(environment, lang),
  };
}
